
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1935_48)","fill":"#94929B"}},[_c('path',{attrs:{"d":"M16 2a1 1 0 01.993.883L17 3v1h1a3 3 0 012.995 2.824L21 7v12a3 3 0 01-2.824 2.995L18 22H6a3 3 0 01-2.995-2.824L3 19V7a3 3 0 012.824-2.995L6 4h1V3a1 1 0 011.993-.117L9 3v1h6V3a1 1 0 011-1zm3 7H5v9.625c0 .705.386 1.286.883 1.366L6 20h12c.513 0 .936-.53.993-1.215l.007-.16V9z"}}),_c('path',{attrs:{"d":"M12 12a1 1 0 01.993.883L13 13v3a1 1 0 01-1.993.117L11 16v-2a1 1 0 01-.117-1.993L11 12h1z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1935_48"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    